import React, { useState } from "react";
import SimpleImageSlider from "react-simple-image-slider";
export default function ImagesSlider() {
   const [imageNum, setImageNum] = useState(1);
   const sliderImages = [
      {
         url: "https://online.sib.ae/node_modules/speedboat_ui/images/sb_pre/001/ad01.png",
      },
      {
         url: "https://online.sib.ae/node_modules/speedboat_ui/images/sb_pre/001/ad02.png",
      },
      {
         url: "https://online.sib.ae/node_modules/speedboat_ui/images/sb_pre/001/ad03.png",
      },
      {
         url: "https://online.sib.ae/node_modules/speedboat_ui/images/sb_pre/001/ad04.png",
      }
   ];
   return (
      <div>
    
         <SimpleImageSlider
            width={600}
            height={330}
            style={{borderRadius: "4px"}}
            images={sliderImages}
            showBullets={true}
            showNavs={false}
            autoPlay={true} 
            onStartSlide = {(index, length) => {
               setImageNum(index);
            }}
               autoPlayDelay = {3}
         />
       
      </div>
   );
}